var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("test")]),_c('iframe',{staticClass:"stripe-iframe",attrs:{"src":"https://buy.stripe.com/00gbJVf0QdxTcq4dQQ?locale=sv"}})])
}]

export { render, staticRenderFns }